import { APIResponseType } from "../../../../../types/generics/APIResponse.type";
import {
  createDeleteApiHook,
  createGetApiHook,
  createPostApiHook,
  createPatchApiHook,
  tokenSourceFn,
} from "../../../../../services/api/apiHooks";
import { FlashCardData } from "../types/NewKaraoke";
import axios from "axios";
import { API_BASE_URL } from "../../../../../services/api/axiosConfig";

const createFlashCard = `/flash-cards`;

type cardQueryParams = Record<string, any>;

const getAllFlashCardAPI = (queryParams: cardQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/flash-cards?${queryString}`;
};

const getFlashCardById = ({ id }: { id: number }) => `/flash-cards/${id}`;

export const useCreateFlashCard = createPostApiHook<
  {},
  { headers: Record<any, any> },
  APIResponseType<FlashCardData>
>(createFlashCard, {
  isFormDataMethod: false,
});

export const useGetAllFlashCards = createGetApiHook<
  APIResponseType<FlashCardData[]>,
  {}
>(getAllFlashCardAPI);

export const useGetFlashCardByID = createGetApiHook<
  APIResponseType<FlashCardData>,
  { id: number }
>(getFlashCardById);

const getAllFlashCardByTalentAPI = (
  queryParams: cardQueryParams = {},
): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/flash-cards/me?${queryString}`;
};

export const useGetAllFlashCardByTalent = createGetApiHook<
  APIResponseType<FlashCardData[]>,
  {}
>(getAllFlashCardByTalentAPI);

export const useEditFlashCard = createPatchApiHook<
  {},
  { id: number },
  APIResponseType<FlashCardData>
>(getFlashCardById, {
  isFormDataMethod: false,
});

export const useDeleteFlashCard = createDeleteApiHook<
  {},
  { id: number },
  APIResponseType<any>
>(getFlashCardById, {
  isFormDataMethod: false,
});

const bookFlashCard = () => `/flash-cards/booking`;

export const useBookFlashCard = createPostApiHook<
  { flash_card_id: number },
  {},
  APIResponseType<any>
>(bookFlashCard, {
  isFormDataMethod: false,
});

const getAllFlashCardBookings = (queryParams: cardQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/flash-cards/bookings?${queryString}`;
};

export const useGetAllFlashCardBookings = createGetApiHook<
  APIResponseType<any[]>,
  {}
>(getAllFlashCardBookings);

// export const startFlashCallFn = async (
//   talentId: string,
//   flashCardId: number,
//   isBusinessView?: boolean
// ) => {
//   try {
//     const response = await axios.post(
//       API_BASE_URL + `/flash-cards/start/${flashCardId}`,
//       {},
//       {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           "talent-id": talentId,
//           Authorization: `Bearer ${tokenSourceFn()}`,
//         },
//       }
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

const startFlashCardAPI = ({ id }: { id: number }) =>
  `/flash-cards/start/${id}`;
export const useStartFlashCard = createPostApiHook<
  {},
  { id: number; headers?: { "talent-id": string } },
  APIResponseType<any>
>(startFlashCardAPI, {
  isFormDataMethod: false,
});

export const joinFlashCallFn = async (flashCardId: number) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/flash-cards/join/${flashCardId}`,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const endFlashCallFn = async (flashCardId: number, talentId: string) => {
//   try {
//     const response = await axios.post(
//       API_BASE_URL + `/flash-cards/end/${flashCardId}`,
//       {},
//       {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           "talent-id": talentId,
//           Authorization: `Bearer ${tokenSourceFn()}`,
//         },
//       }
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

const endFlashCardAPI = ({ id }: { id: number }) => `/flash-cards/end/${id}`;
export const useEndFlashCard = createPostApiHook<
  { stream_id?: string },
  { id: number; headers?: { "talent-id": string } },
  APIResponseType<any>
>(endFlashCardAPI, {
  isFormDataMethod: false,
});

const getStartPeeping = ({ id }: { id: string }) =>
  `/flash-cards/peeping/${id}/start`;

const getEndPeeping = ({ id }: { id: string }) =>
  `/flash-cards/peeping/${id}/end`;

export const useStartPeeping = createPostApiHook<
  {},
  { id: string },
  APIResponseType<any>
>(getStartPeeping, {
  isFormDataMethod: false,
});

export const useEndPeeping = createPostApiHook<
  {},
  { id: string },
  APIResponseType<any>
>(getEndPeeping, {
  isFormDataMethod: false,
});

const flashCardPurchaseStatusAPI = ({ id }: { id: number }) =>
  `/flash-cards/${id}/purchase-status`;

export const useGetFlashCardPurchaseStatus = createGetApiHook<
  APIResponseType<any>,
  { id: number }
>(flashCardPurchaseStatusAPI);

// YouTube Publish API endpoints
const youtubePublishAPI = () => `/agora/youtube-publish`;

const youtubePublishByConverterIdAPI = ({
  converterId,
}: {
  converterId: string;
}) => `/agora/youtube-publish/${converterId}`;

// POST: Start YouTube publish - returns converterId
export interface StartYouTubePublishPayload {
  channel_name: string;
  uuid: string;
  stream_key: string;
  youtube_rtmp: string;
}

export interface YouTubePublishResponse {
  converterId: string;
  [key: string]: any;
}

export const useStartYouTubePublish = createPostApiHook<
  StartYouTubePublishPayload,
  {},
  APIResponseType<YouTubePublishResponse>
>(youtubePublishAPI, {
  isFormDataMethod: false,
});

// POST: End YouTube publish
export const useEndYouTubePublish = createPostApiHook<
  {},
  { converterId: string },
  APIResponseType<any>
>(youtubePublishByConverterIdAPI, {
  isFormDataMethod: false,
});

// GET: Get YouTube live information
export interface YouTubeLiveInfo {
  converterId?: string;
  status?: string;
  [key: string]: any;
}

export const useGetYouTubeLiveInfo = createGetApiHook<
  APIResponseType<YouTubeLiveInfo[]>,
  {}
>(youtubePublishAPI);

// GET: Get YouTube live information by converterId
export const useGetYouTubeLiveInfoByConverterId = createGetApiHook<
  APIResponseType<YouTubeLiveInfo>,
  { converterId: string }
>(youtubePublishByConverterIdAPI);

// ---------------------------------------------------------------------------
// YouTube Live Metadata (title, description, clickable link) - googleapis
// Backend: POST /agora/youtube-metadata with body { title?, description?, link?, access_token }
// Backend should call liveBroadcasts.update ~15s after stream starts.
// ---------------------------------------------------------------------------
const youtubeMetadataAPI = () => `/agora/youtube-metadata`;

export interface UpdateYouTubeMetadataPayload {
  title?: string;
  description?: string;
  link?: string;
  access_token: string;
}

export const useUpdateYouTubeMetadata = createPostApiHook<
  UpdateYouTubeMetadataPayload,
  {},
  APIResponseType<any>
>(youtubeMetadataAPI, {
  isFormDataMethod: false,
});
